function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from "react";
import PropTypes from "prop-types";

var Toast = function (_React$Component) {
  _inherits(Toast, _React$Component);

  function Toast(props) {
    _classCallCheck(this, Toast);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.getBarStyle = _this.getBarStyle.bind(_this);
    _this.getActionStyle = _this.getActionStyle.bind(_this);
    _this.getTitleStyle = _this.getTitleStyle.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);

    if (props.onDismiss && props.isActive) {
      _this.dismissTimeout = setTimeout(props.onDismiss, props.dismissAfter);
    }
    return _this;
  }

  Toast.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.dismissAfter === false) return;

    // See http://eslint.org/docs/rules/no-prototype-builtins
    if (!{}.hasOwnProperty.call(nextProps, "isLast")) {
      clearTimeout(this.dismissTimeout);
    }

    if (nextProps.onDismiss) {
      if (nextProps.isActive && !this.props.isActive || nextProps.dismissAfter && this.props.dismissAfter === false) {
        this.dismissTimeout = setTimeout(nextProps.onDismiss, nextProps.dismissAfter);
      }
    }
  };

  Toast.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.props.dismissAfter) clearTimeout(this.dismissTimeout);
  };

  /*
  * @description Dynamically get the styles for the bar.
  * @returns {object} result The style.
  */


  Toast.prototype.getBarStyle = function getBarStyle() {
    if (this.props.style === false) return {};

    var _props = this.props,
        isActive = _props.isActive,
        barStyle = _props.barStyle,
        activeBarStyle = _props.activeBarStyle;


    var baseStyle = {
      position: "fixed",
      bottom: "2rem",
      left: "-100%",
      width: "auto",
      padding: "1rem",
      margin: 0,
      color: "#fafafa",
      font: "1rem normal Roboto, sans-serif",
      borderRadius: "5px",
      background: "#212121",
      borderSizing: "border-box",
      boxShadow: "0 0 1px 1px rgba(10, 10, 11, .125)",
      cursor: "default",
      WebKitTransition: ".5s cubic-bezier(0.89, 0.01, 0.5, 1.1)",
      MozTransition: ".5s cubic-bezier(0.89, 0.01, 0.5, 1.1)",
      msTransition: ".5s cubic-bezier(0.89, 0.01, 0.5, 1.1)",
      OTransition: ".5s cubic-bezier(0.89, 0.01, 0.5, 1.1)",
      transition: ".5s cubic-bezier(0.89, 0.01, 0.5, 1.1)",
      WebkitTransform: "translatez(0)",
      MozTransform: "translatez(0)",
      msTransform: "translatez(0)",
      OTransform: "translatez(0)",
      transform: "translatez(0)"
    };

    return isActive ? Object.assign({}, baseStyle, { left: "1rem" }, barStyle, activeBarStyle) : Object.assign({}, baseStyle, barStyle);
  };

  /*
  * @function getActionStyle
  * @description Dynamically get the styles for the action text.
  * @returns {object} result The style.
  */


  Toast.prototype.getActionStyle = function getActionStyle() {
    return this.props.style !== false ? Object.assign({}, {
      padding: "0.125rem",
      marginLeft: "1rem",
      color: "#f44336",
      font: ".75rem normal Roboto, sans-serif",
      lineHeight: "1rem",
      letterSpacing: ".125ex",
      textTransform: "uppercase",
      borderRadius: "5px",
      cursor: "pointer"
    }, this.props.actionStyle) : {};
  };

  /*
  * @function getTitleStyle
  * @description Dynamically get the styles for the title.
  * @returns {object} result The style.
  */


  Toast.prototype.getTitleStyle = function getTitleStyle() {
    return this.props.style !== false ? Object.assign({}, {
      fontWeight: "700",
      marginRight: ".5rem"
    }, this.props.titleStyle) : {};
  };

  /*
  * @function handleClick
  * @description Handle click events on the action button.
  */


  Toast.prototype.handleClick = function handleClick() {
    if (this.props.onClick && typeof this.props.onClick === "function") {
      return this.props.onClick();
    }
  };

  Toast.prototype.render = function render() {
    var className = "notification-bar";

    if (this.props.isActive) className += " " + this.props.activeClassName;
    if (this.props.className) className += " " + this.props.className;

    var _props2 = this.props,
        title = _props2.title,
        action = _props2.action,
        message = _props2.message;


    return React.createElement(
      "div",
      { className: className, style: this.getBarStyle() },
      React.createElement(
        "div",
        { className: "notification-bar-wrapper" },
        title && React.createElement(
          "span",
          {
            className: "notification-bar-title",
            style: this.getTitleStyle()
          },
          title
        ),
        React.createElement(
          "span",
          { className: "notification-bar-message" },
          message
        ),
        action && React.createElement(
          "button",
          {
            className: "notification-bar-action",
            onClick: this.handleClick,
            style: this.getActionStyle()
          },
          action
        )
      )
    );
  };

  return Toast;
}(React.Component);

Toast.propTypes = process.env.NODE_ENV !== "production" ? {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  action: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.node]),
  onClick: PropTypes.func,
  style: PropTypes.bool,
  actionStyle: PropTypes.object,
  titleStyle: PropTypes.object,
  barStyle: PropTypes.object,
  activeBarStyle: PropTypes.object,
  dismissAfter: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  onDismiss: PropTypes.func,
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  isActive: PropTypes.bool,
  title: PropTypes.string
} : {};

Toast.defaultProps = {
  isActive: false,
  dismissAfter: 2000,
  activeClassName: "notification-bar-active"
};

export default Toast;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/es/components/toast/toast.js
// module id = null
// module chunks = 